(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
  window.addToCart = function (variantId, quantity, button) {
    // Set loading state
    if (button) {
      button.textContent = 'Menambah..';
      button.disabled = true;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok');
      })
      .then((data) => {
        // Update cart count in all elements
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            // Update cart badges
            const cartBadges = document.querySelectorAll(
              '.np-cart-badge, .badge-cart, .badge-cart-drawer, .badge-floatingcart, [data-cart-count]'
            );
            cartBadges.forEach((badge) => {
              badge.textContent = cart.item_count;
              badge.setAttribute('title', cart.item_count);
            });

            // Update floating cart completely
            if (cart.item_count > 0) {
              fetch('/search?view=cart')
                .then((response) => response.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newFloatingCart = doc.querySelector('div#floatingCart');
                  const currentFloatingCart = document.getElementById('floatingCart');
                  if (newFloatingCart && currentFloatingCart) {
                    currentFloatingCart.innerHTML = newFloatingCart.innerHTML;
                    currentFloatingCart.classList.remove('dn');
                  }
                })
                .catch((error) => console.error('Error updating floating cart:', error));
            } else {
              const floatingCart = document.getElementById('floatingCart');
              if (floatingCart) {
                floatingCart.innerHTML = '';
                floatingCart.classList.add('dn');
              }
            }

            // Update cart drawer if exists
            const cartDrawer = document.getElementById('ajax-drawer');
            if (cartDrawer) {
              // Use existing jQuery functions if available
              if (typeof updateDrawerLangganan === 'function' && typeof updateDrawerNonLangganan === 'function') {
                updateDrawerLangganan();
                updateDrawerNonLangganan();
              } else {
                // Fallback: Fetch updated cart drawer content
                fetch('/cart?view=drawer')
                  .then((response) => response.text())
                  .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newDrawer = doc.querySelector('#ajax-drawer');
                    if (newDrawer) {
                      cartDrawer.innerHTML = newDrawer.innerHTML;
                    }
                  })
                  .catch((error) => console.error('Error updating cart drawer:', error));
              }
            }
          })
          .catch((error) => console.error('Error fetching cart data:', error))
          .finally(() => {
            // Reset button state and show quantity counter
            if (button) {
              button.textContent = 'Beli';
              button.disabled = false;

              // Hide buy button and show quantity counter
              const variantId = button.onclick.toString().match(/addToCart\((\d+)/)[1];
              const buyButtonContainer = document.querySelector('.buy-button-container-' + variantId);
              const quantityCounter = document.querySelector('.counter-' + variantId);

              if (buyButtonContainer && quantityCounter) {
                buyButtonContainer.classList.add('dn');
                quantityCounter.classList.remove('dn');

                // Update quantity input to 1
                const quantityInput = quantityCounter.querySelector('.quantity-cart-' + variantId);
                if (quantityInput) {
                  quantityInput.value = '1';
                }
              }
            }
          });
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        // Reset button state on error
        if (button) {
          button.textContent = 'Beli';
          button.disabled = false;
        }
      });
  };

  window.updateQuantity = function (variantId, change) {
    const quantityInput = document.querySelector('.quantity-cart-' + variantId);
    if (!quantityInput) return;

    const currentQuantity = parseInt(quantityInput.value) || 0;
    const newQuantity = Math.max(0, currentQuantity + change);

    if (newQuantity === 0) {
      // Remove from cart and show buy button
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Hide quantity counter and show buy button
          const buyButtonContainer = document.querySelector('.buy-button-container-' + variantId);
          const quantityCounter = document.querySelector('.counter-' + variantId);

          if (buyButtonContainer && quantityCounter) {
            buyButtonContainer.classList.remove('dn');
            quantityCounter.classList.add('dn');
          }

          // Update cart displays
          updateCartDisplays();
        })
        .catch((error) => console.error('Error removing from cart:', error));
    } else {
      // Update quantity
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          quantityInput.value = newQuantity;
          // Update cart displays
          updateCartDisplays();
        })
        .catch((error) => console.error('Error updating quantity:', error));
    }
  };

  function updateCartDisplays() {
    // Update cart count and displays
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // Update cart badges
        const cartBadges = document.querySelectorAll(
          '.np-cart-badge, .badge-cart, .badge-cart-drawer, .badge-floatingcart, [data-cart-count]'
        );
        cartBadges.forEach((badge) => {
          badge.textContent = cart.item_count;
          badge.setAttribute('title', cart.item_count);
        });

        // Update floating cart
        if (cart.item_count > 0) {
          fetch('/search?view=cart')
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newFloatingCart = doc.querySelector('div#floatingCart');
              const currentFloatingCart = document.getElementById('floatingCart');
              if (newFloatingCart && currentFloatingCart) {
                currentFloatingCart.innerHTML = newFloatingCart.innerHTML;
                currentFloatingCart.classList.remove('dn');
              }
            })
            .catch((error) => console.error('Error updating floating cart:', error));
        } else {
          const floatingCart = document.getElementById('floatingCart');
          if (floatingCart) {
            floatingCart.innerHTML = '';
            floatingCart.classList.add('dn');
          }
        }

        // Update cart drawer
        const cartDrawer = document.getElementById('ajax-drawer');
        if (cartDrawer) {
          if (typeof updateDrawerLangganan === 'function' && typeof updateDrawerNonLangganan === 'function') {
            updateDrawerLangganan();
            updateDrawerNonLangganan();
          } else {
            fetch('/cart?view=drawer')
              .then((response) => response.text())
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawer = doc.querySelector('#ajax-drawer');
                if (newDrawer) {
                  cartDrawer.innerHTML = newDrawer.innerHTML;
                }
              })
              .catch((error) => console.error('Error updating cart drawer:', error));
          }
        }
      })
      .catch((error) => console.error('Error fetching cart data:', error));
  }

  document.addEventListener('DOMContentLoaded', function () {
    const carouselTrack = document.querySelector('.carousel-track');
    const slides = document.querySelectorAll('.carousel-slide');
    const dots = document.querySelectorAll('.dot');
    const carouselContainer = document.querySelector('.carousel-container');

    let currentIndex = 0;
    let slidesToShow = window.innerWidth <= 990 ? 1 : 3;
    let totalSlides = slides.length;
    let maxIndex;

    // Calculate maxIndex based on slidesToShow
    if (slidesToShow === 1) {
      // Mobile: can navigate to each individual slide
      maxIndex = Math.max(0, totalSlides - 1);
    } else {
      // Desktop: navigate by groups
      maxIndex = Math.max(0, totalSlides - slidesToShow);
    }

    // Auto-play functionality
    let autoPlayInterval;

    // Touch/Swipe variables
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTransform = 0;

    // Update carousel dimensions and position
    function updateCarousel() {
      const oldSlidesToShow = slidesToShow;
      slidesToShow = window.innerWidth <= 990 ? 1 : 3;

      console.log(
        'UpdateCarousel called - Old slides:',
        oldSlidesToShow,
        'New slides:',
        slidesToShow,
        'Width:',
        window.innerWidth
      );

      if (slidesToShow === 1) {
        // Mobile: can navigate to each individual slide
        maxIndex = Math.max(0, totalSlides - 1);
      } else {
        // Desktop: navigate by groups
        maxIndex = Math.max(0, totalSlides - slidesToShow);
      }

      // Adjust current index if needed
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      // Force refresh carousel container styles
      carouselContainer.style.transform = 'translateX(0px)';

      updateDotsVisibility();
      moveToSlide(currentIndex);
      updateDots(); // Update active dot after resize

      console.log('Carousel updated - CurrentIndex:', currentIndex, 'MaxIndex:', maxIndex);
    }

    // Move to specific slide with smooth animation
    function moveToSlide(index, duration = 0.6) {
      // Ensure index is within valid bounds
      const newIndex = Math.max(0, Math.min(index, maxIndex));
      currentIndex = newIndex;

      const slideWidth = slides[0].offsetWidth;
      const gap = 20;
      const translateX = -(currentIndex * (slideWidth + gap));

      gsap.to(carouselTrack, {
        x: translateX,
        duration: duration,
        ease: 'power2.out',
        onComplete: function () {
          updateDots();
        },
      });
    }

    // Update dots visibility and create dynamic dots based on groups
    function updateDotsVisibility() {
      const dotsContainer = document.querySelector('.review-dots');
      if (!dotsContainer) return;

      // Calculate number of dots needed
      let totalDots;
      if (slidesToShow === 1) {
        // Mobile: one dot per slide
        totalDots = totalSlides;
      } else {
        // Desktop: one dot per group
        totalDots = Math.ceil(totalSlides / slidesToShow);
      }

      // Clear existing dots
      dotsContainer.innerHTML = '';

      // Only show dots if there are more than 1 dot needed
      if (totalDots > 1) {
        dotsContainer.style.display = 'flex';

        // Create dots dynamically
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('span');
          dot.className = 'dot';
          dot.addEventListener('click', function () {
            let targetIndex;
            if (slidesToShow === 1) {
              // Mobile: each dot represents one slide
              targetIndex = i;
            } else {
              // Desktop: each dot represents a group
              targetIndex = Math.min(i * slidesToShow, maxIndex);
            }
            moveToSlide(targetIndex);
          });
          dotsContainer.appendChild(dot);
        }
      } else {
        dotsContainer.style.display = 'none';
      }
    }

    // Update active dot
    function updateDots() {
      const dots = document.querySelectorAll('.dot');

      dots.forEach((dot, index) => {
        dot.classList.remove('active');

        if (slidesToShow === 1) {
          // Mobile: direct index match
          if (currentIndex === index) {
            dot.classList.add('active');
          }
        } else {
          // Desktop: group-based matching
          const dotTargetIndex = Math.min(index * slidesToShow, maxIndex);
          if (currentIndex === dotTargetIndex) {
            dot.classList.add('active');
          }
        }
      });
    }

    // Touch/Swipe functionality
    function handleTouchStart(e) {
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      currentX = startX;
      isDragging = true;

      const currentTransform = gsap.getProperty(carouselTrack, 'x');
      startTransform = currentTransform;

      // stopAutoPlay();
      carouselTrack.style.cursor = 'grabbing';
    }

    function handleTouchMove(e) {
      if (!isDragging) return;

      e.preventDefault();
      currentX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = currentX - startX;

      gsap.set(carouselTrack, {
        x: startTransform + deltaX,
      });
    }

    function handleTouchEnd(e) {
      if (!isDragging) return;

      isDragging = false;
      carouselTrack.style.cursor = 'grab';

      const deltaX = currentX - startX;
      const threshold = 50;

      if (Math.abs(deltaX) > threshold) {
        if (deltaX > 0 && currentIndex > 0) {
          // Swipe right - previous slide
          moveToSlide(currentIndex - 1);
        } else if (deltaX < 0 && currentIndex < maxIndex) {
          // Swipe left - next slide
          moveToSlide(currentIndex + 1);
        } else {
          // Snap back to current position
          moveToSlide(currentIndex);
        }
      } else {
        // Snap back to current position
        moveToSlide(currentIndex);
      }

      startAutoPlay();
    }

    // Add touch event listeners
    carouselContainer.addEventListener('touchstart', handleTouchStart, { passive: false });
    carouselContainer.addEventListener('touchmove', handleTouchMove, { passive: false });
    carouselContainer.addEventListener('touchend', handleTouchEnd);

    // Add mouse event listeners for desktop drag
    carouselContainer.addEventListener('mousedown', handleTouchStart);
    document.addEventListener('mousemove', handleTouchMove);
    document.addEventListener('mouseup', handleTouchEnd);

    // Prevent text selection during drag
    carouselContainer.addEventListener('selectstart', (e) => e.preventDefault());

    // Handle window resize with debouncing for better performance
    let resizeTimeout;
    window.addEventListener('resize', function () {
      console.log('Window resize detected:', window.innerWidth);
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        console.log('Updating carousel for new width:', window.innerWidth);
        // stopAutoPlay();
        updateCarousel();

        // Restart auto-play if conditions are met
        // if (totalSlides > slidesToShow) {
        //   startAutoPlay();
        // }
      }, 150); // Debounce delay of 150ms
    });

    // Also listen for orientationchange event (mobile devices)
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        console.log('Orientation change detected:', window.innerWidth);
        updateCarousel();
      }, 200);
    });

    // Use matchMedia for more reliable breakpoint detection
    const mobileMediaQuery = window.matchMedia('(max-width: 990px)');
    function handleMediaQueryChange(e) {
      // console.log('Media query change detected - Mobile:', e.matches, 'Width:', window.innerWidth);
      updateCarousel();
    }

    // Add listener for media query changes
    if (mobileMediaQuery.addListener) {
      mobileMediaQuery.addListener(handleMediaQueryChange);
    } else {
      // Modern browsers
      mobileMediaQuery.addEventListener('change', handleMediaQueryChange);
    }

    // Initialize carousel
    function initCarousel() {
      totalSlides = slides.length;
      if (totalSlides === 0) return;

      updateCarousel();

      // Ensure dots are updated after initialization
      setTimeout(() => {
        updateDots();
      }, 100);
    }

    initCarousel();
  });

  } catch(e) { console.error(e); }
})();
})();
